import React from "react";
import { isDashboardType } from "../../utils/Types";

export function CardSimpleHeader({ ...props }) {
    return (
        <>
            <div
                className="card-header d-flex align-items-center justify-content-between"
                style={{
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    ...props.style,
                }}
                ref={element => {
                    if (element && isDashboardType(props)) {
                        element.style.setProperty('padding-bottom', '0', 'important');
                    }
                }}
            >
                <div className="d-flex align-items-center">
                    {props.rightComponent && props.rightComponent}
                </div>

                <span
                    className={`${props.subtitleClass || ''}`}
                    style={{
                        marginLeft: '12px',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {props.subtitle}
                </span>
            </div>
        </>
    );
}